export default __webpack_public_path__ + "static/media/s1.bcd2c453.png";